






























































































































































































































































































































import { isViewAsSelected } from "@/store/modules/TargetUserModule";
import { Ref, Component, Watch, Vue } from "vue-property-decorator";
import { formatDateShort } from "@/utils/DateFormatter";
import { firestore } from "firebase/app";

import { observeProjectStatus } from "@/data/repository/ProjectStatusRepository";
import { observeProjectLogs, observeProjectSyncedNotes, addProjectEventLog } from "@/data/repository/ProjectLogRepository";

import { ProjectStatusData } from "@/data/models/ProjectStatusData";
import { ProjectLogData, ProjectSyncedNotes, createProjectEventLog, ProjectEventType, ContactPersonEventInfo } from "@/data/models/ProjectLog";

import {
  ProjectDetails,
  ContactPersonInfo,
  ApprovalResult,
  mapApartmentsForElectricityBillingToContactPersons,
  isProjectFinished,
  ProjectConclusionState,
  getProjectEndDateLegacy,
  isPortalOnlyProject,
  getProjectTypeIdOfProject,
  doesProjectTypeIdHaveDrying,
} from "@/data/models/ProjectDetails";

import { ProjectMetaData } from "@/data/models/ProjectMetaData";
import { ClientPanelAssignment } from "@/data/models/ClientPanelAssignment";
import Report from "@/data/models/Report";
import { ProjectDetailsModule } from "@/store/modules/ProjectDetailsModule";
import { ProjectOwnershipUpdate } from "@/components/project/detail/SetProjectOwnership.vue";

import {
  getProjectDetails,
  createNewProject,
  saveProject,
  setProjectOwnership,
  isDryingProject,
  deleteProject,
  observeProjectMetaData,
  observeProject,
  ProjectSaveResult,
  NewProjectScope,
  ProjectRetrievalErrorState,
  restoreProject,
  moveProjectToFinished,
  reopenProject
} from "@/data/repository/ProjectRepository";

import { observeNotesOfProject } from "@/data/repository/ProjectNotesRepository";

import router from "@/router/router";

import {
  observeClientPanelAssignmentsOfProject,
  updateContactPersonOfClientPanelAssignments,
} from "@/data/repository/ClientPanelAssignmentRepository";
import { observeReportsOfProject } from "@/data/repository/ReportRepository";
import { observeMeasurementProtocolData } from "@/data/repository/MeasurementProtocolRepository";

import {
  doesClientHaveApp,
  getBranchesOfClient,
  getClientId,
  getProjectManagement,
  getProjectManagementType,
  isExternalSystem,
  isSimulatingErp,
} from "@/data/repository/ClientRepository";

import clone from "clone";
import { ProjectManagement } from "@/data/models/Client";
import { ProjectDetailsTab } from "@/data/models/ProjectDetailsTab";

import ProjectDevicesComponent from "@/components/project/devices/ProjectDevices.vue";
import ConcludeProjectComponent from "@/components/project/conclusion/ConcludeProject.vue";
import ClientDataDetailsComponent from "@/components/project/clientdata/ClientDataDetails.vue";
import ConfirmationDialogComponent from "@/components/common/ConfirmationDialog.vue";
import ProjectNotesComponent from "@/components/project/notes/ProjectNotes.vue";
import FindIresDeviceForProjectAssignmentComponent from "@/components/devices/FindIresDeviceForProjectAssignment.vue";

import MenuIconWithSelectionListComponent from "@/components/common/FilterMenu.vue";

import SelectClientPanelComponent from "@/components/devices/SelectClientPanel.vue";

import AssignIresDeviceToProjectComponent from "@/components/project/devices/AssignIresDeviceToProject.vue";
import ReportListComponent from "@/components/report/ReportList.vue";
import PdeViewerComponent from "@/components/report/PdeViewer.vue";
import BeschreibungViewerComponent from "@/components/report/BeschreibungViewer.vue";
import ProjectStatusComponent from "@/components/project/status/ProjectStatus.vue";
import ProjectLogBookComponent from "@/components/project/logbook/ProjectLogBook.vue";
import DocumentListComponent from "@/components/project/documents/DocumentList.vue";

import { ToolbarContentModule } from "@/store/modules/ToolbarContent";
import DisposeBeforeDestroyComponent from "@/components/common/DisposeBeforeDestroyComponent.vue";
import { saveProjectStep } from "@/data/repository/ProjectStatusRepository";
import {
  findNickname,
  getActiveUser,
  getRecordInfo,
} from "@/data/repository/UserRepository";
import { ProjectNote } from "@/data/models/ProjectNote";
import { MeasurementProtocolData } from "@/data/models/MeasurementProtocolData";
import { ButtonState } from "@/components/common/StateButton.vue";
import ClientDataSectionComponent from "@/components/project/clientdata/ClientDataSection.vue";
import ClientPanel from "@/data/models/ClientPanel";
import { getBoolean, setBoolean, setString } from "@/utils/SecureLocalStorage";
import { filterUniqueByField } from "@/utils/Utils";
import { getDeviceCountInfo, getDeviceTabCount } from "@/utils/ProjectDeviceCount";
import { isGenericDeviceAssignmentShown } from "@/utils/GenericDeviceAssignmentUtils";
import ClosedIresDetailsAssignmentDetailsComponent from "../devices/ClosedIresDeviceAssignmentDetails.vue";
import { ProjectSortOrder } from "@/data/models/ProjectSortOrder";
import { updateComBox } from "@/data/repository/ComBoxRepository";
import { observeGenericDeviceAssignmentsOfProject } from "@/data/repository/GenericDeviceAssignmentRepository";
import { GenericDeviceProjectAssignment } from "@/data/models/GenericDeviceAssignment";
import {
  manageAllDevicesClientAccess,
  manageTimeTrackingClientAccess
} from "@/permissions/ClientPermissions";
import { 
  alwaysAllowedToEditDeviceAssignmentsAccess, 
  alwaysAllowedToViewTimeTrackingAccess,
  restoreProjectAccess, 
  deleteProjectAccess, 
  editProjectAccess,
  moveProjectAccess, 
  reopenProjectAccess
} from "@/permissions/UserPermissions";
import { getProjectOverview } from "@/data/repository/ProjectOverviewRepository";
import {
  getOpenProjectTimeTrackingLogs,
  getProjectLogTaskLabel,
} from "@/data/repository/TimeTrackingRepository";
import { DryingProjectOverview } from "@/data/models/DryingProjectOverview";
import { createContainerForProjectSteps, hasStepStarted } from "@/data/models/ProjectSteps";
import { getProjectSettingsV2, ProjectSettingsOptions } from "@/data/models/Settings";
import { isDeviceAssignmentAllowedByProjectState } from "@/data/models/ProjectState";
import { ProjectManagementSettingsModule } from "@/store/modules/ProjectManagementSettingsModule";
import { ClientModule } from "@/store/modules/ClientModule";
import { COLOR_APP_BAR_DARK, COLOR_PROJECT_DETAILS_SELECTED_TAB } from "@/utils/colors";
import { themed } from "@/utils/Theme";
import { groupAndSortReports } from "@/utils/ReportGrouping";
import { UserModule } from "@/store/modules/UserModule";
import { SnackbarModule } from "@/store/modules/SnackbarModule";
import SelectDeviceDialogComponent from "@/components/devices/SelectDeviceDialog.vue";
import { isClientPanel } from "@/data/models/DeviceSettingsManager";
import AssignGenericDeviceToProjectComponent from "../devices/AssignGenericDeviceToProject.vue";
import { DeviceOverview } from "@/data/models/DeviceOverview";
import { shouldShowMoveOrReopenProjectFab } from "@/utils/ProjectDetailsFabVisibility";
import { PROJECT_DETAILS_TAB_ICONS, splitPhoneTabs } from "@/utils/ProjectDetailsPhoneTabs";

enum AssignmentFilter {
  ALL,
  OPEN_ENDED,
}

interface PanelsToBeReleased {
  clientPanelAssignment: ClientPanelAssignment;
  clientPanel: ClientPanel;
  contactPersonInfo: ContactPersonInfo;
}

@Component({
  name: "ProjectDetailsComponent",
  components: {
    "client-data-section": ClientDataSectionComponent,
    "project-status": ProjectStatusComponent,
    "project-log-book": ProjectLogBookComponent,
    "menu-icon": MenuIconWithSelectionListComponent,
    "confirmation-dialog": ConfirmationDialogComponent,
    "project-devices": ProjectDevicesComponent,
    "client-data": ClientDataDetailsComponent,
    "report-list": ReportListComponent,
    "pde-viewer": PdeViewerComponent,
    "beschreibung-viewer": BeschreibungViewerComponent,
    "document-list": DocumentListComponent,
    "conclude-project": ConcludeProjectComponent,
    "find-ires-device-for-project-assignment": FindIresDeviceForProjectAssignmentComponent,
    "assign-ires-device": AssignIresDeviceToProjectComponent,
    "assign-generic-device": AssignGenericDeviceToProjectComponent,
    "select-panel": SelectClientPanelComponent,
    "select-device": SelectDeviceDialogComponent,
    "project-notes": ProjectNotesComponent,
    "closed-assignment-details": ClosedIresDetailsAssignmentDetailsComponent,
  },
  mixins: [DisposeBeforeDestroyComponent],
})
export default class ProjectDetailsComponent extends Vue {
  @Ref("findIresDeviceForProjectAssignment")
  findIresDeviceForProjectAssignment!: FindIresDeviceForProjectAssignmentComponent;

  @Ref("selectPanel")
  selectClientPanel!: SelectClientPanelComponent;

  @Ref("selectDevice")
  selectDevice!: SelectDeviceDialogComponent;

  @Ref("assignIresDevice")
  assignIresDevice!: AssignIresDeviceToProjectComponent;

  @Ref("assignGenericDevice")
  assignGenericDevice!: AssignGenericDeviceToProjectComponent;

  @Ref("confirm")
  confirmationDialogComponent!: ConfirmationDialogComponent;

  @Ref("projectDevices")
  projectDevicesComponent!: ProjectDevicesComponent;

  @Ref("closedAssignmentDetails")
  closedAssignmentDetailsComponent!: ClosedIresDetailsAssignmentDetailsComponent;

  /** Expose enum for template usage */
  readonly Tab = ProjectDetailsTab;

  skipedFirstProjectChange = false;

  projectOverview: DryingProjectOverview | null = null;
  projectDetails: ProjectDetails = createNewProject(
    getProjectManagementType() === ProjectManagement.PROJECT_OPTION
      ? NewProjectScope.FLEX 
      : NewProjectScope.DRYING,
    false
  );
  projectStatus: ProjectStatusData | null = null;
  projectLogs: ProjectLogData | null = null;
  projectSyncedNotes: ProjectSyncedNotes | null = null;

  isNewProject = true;
  isApprovalDecisionChanged = false;
  hasFlexScope = false;
  updateRoomsData = false;

  initialProjectApproval = this.projectDetails.clientData.projectApproval ?? null;

  isProjectTypeChanged = false;

  areProjectDetailsLoaded = false;

  lastProjectLoadTimestamp?: Date = undefined;

  selectedTab = ProjectDetailsTab.CLIENT_DATA;

  /** Report currently being viewed in the PDE viewer (null = show report list) */
  pdeViewerReport: Report | null = null;

  /** Report currently being viewed in the Beschreibung viewer (null = show report list) */
  beschreibungViewerReport: Report | null = null;

  clientId = getClientId();

  cockpitCardType = router.currentRoute.query["cockpitCardType"];
  ignoreUserRequirements = router.currentRoute.query["ignoreUserRequirements"];
  sortOrder = router.currentRoute.query["sortOrder"];
  isProjectsTab = router.currentRoute.query["isProjectsTab"];

  isExternalSystem = isExternalSystem();
  doesClientHaveApp = doesClientHaveApp();

  showNotes = this.clientId === "sfztT2VTtAeNOpcgmdWuIQea4Ve2";

  projectManagement = getProjectManagement();

  currentlyReleasingClientPanel: string | null = null;
  clientPanelsToBeReleased: PanelsToBeReleased[] = [];
  noOfClientPanelsToBeReleased = 0;

  get hyDryDevicesButtonState() {
    if (this.isReadOnlyMode) {
      return ButtonState.DISABLED;
    }

    return this.clientPanelAssignments.length > 0
      ? ButtonState.STEP_BUTTON_COMPLETED
      : ButtonState.STEP_BUTTON_INCOMPLETE;
  }

  get projectSteps() {
    if (!this.projectStatus?.projectSteps) {
      return null;
    }

    return createContainerForProjectSteps(this.projectStatus.projectSteps);
  }

  get isProjectRejected() {
    return this.projectDetails?.clientData?.projectApproval?.approvalResult === ApprovalResult.REJECTED;
  }

  get isProjectWebsiteOnly() {
    if (
      this.isNewProject &&
      this.projectManagement === ProjectManagement.WEBSITE
    ) {
      return true;
    }

    return this.projectDetails ? isPortalOnlyProject(this.projectDetails) : false;
  }

  get isAdministratorClientUser() {
    return ClientModule.isAdministratorClientUser;
  }

  /** Phone layout (below 600 px): move and delete as small floating buttons. */
  get isPhone() {
    return this.$vuetify.breakpoint.xsOnly;
  }

  /** Phones and iPad mini (below 960 px): the icon tab bar instead of the 182 px desktop tabs. */
  get isCompactTabs() {
    return this.$vuetify.breakpoint.smAndDown;
  }

  /** Below the permanent drawer (1264 px): move and delete at the bottom right. */
  get areFloatingButtonsRight() {
    return this.$vuetify.breakpoint.mdAndDown;
  }

  /** Room at the end of the tab, so the floating buttons at the bottom right never cover its last line. */
  get hasFloatingButtonsAtRight() {
    return this.areFloatingButtonsRight && (this.showDeleteProjectButton || this.showMoveProjectButton);
  }

  /** Delete sits left of move on the right: a 40 px (phone) or 56 px button plus the gap. */
  get deleteProjectButtonClass() {
    if (!this.areFloatingButtonsRight || !this.showMoveProjectButton) {
      return "";
    }

    return this.isPhone ? "delete-project-button--phone" : "delete-project-button--right";
  }

  /** Read-only for a finished project, an administrator client, and while "Sicht auf" is active (ticket 2610051). */
  get isReadOnlyMode() {
    return isProjectFinished(this.projectDetails) || this.isAdministratorClientUser || isViewAsSelected();
  }

  get doesProjectIncludeDrying() {
    const projectTypeId = getProjectTypeIdOfProject(this.projectDetails);
    return doesProjectTypeIdHaveDrying(projectTypeId);
  }

  tabs: ProjectDetailsTab[] = [];

  calculateTabs(addReportsTab = true) {
    if (this.projectNotFound) {
      return [ProjectDetailsTab.CLIENT_DATA];
    }

    const tabs = [ProjectDetailsTab.CLIENT_DATA, ProjectDetailsTab.STATUS, ProjectDetailsTab.LOGBOOK];

    if (!this.isProjectRejected) {
      if (isDryingProject(this.projectDetails.id)) {
        if (this.doesProjectIncludeDrying) {
          tabs.push(ProjectDetailsTab.DEVICES);
        }

        if (!this.isProjectWebsiteOnly && this.doesClientHaveApp) {
          tabs.push(ProjectDetailsTab.REPORTS);
        } else {
          if (addReportsTab) {
            tabs.push(
              ProjectDetailsTab.CONCLUDE_PROJECT,
              ProjectDetailsTab.REPORTS
            );
          }
          else {
            tabs.push(
              ProjectDetailsTab.CONCLUDE_PROJECT
            );
          }
          
        }
      } else {
        tabs.push(ProjectDetailsTab.REPORTS);
      }
    }

    if (this.showNotes) {
      tabs.push(ProjectDetailsTab.NOTES);
    }

    return tabs;
  }

  get showAssignmentsFilter() {
    return false; //this.tabs[this.selectedTab] === ProjectDetailsTab.DEVICES;
  }

  allFilters = [AssignmentFilter.OPEN_ENDED, AssignmentFilter.ALL];
  selectedFilter = AssignmentFilter.ALL;

  getFilterName(filter: AssignmentFilter) {
    if (filter === AssignmentFilter.ALL) {
      return this.$t("panelList.filterAllDevices").toString();
    } else {
      return this.$t("panelList.filterInUsage").toString();
    }
  }

  get assignmentHintTitleText() {
    const filterText = this.getFilterName(this.selectedFilter);
    const hintTitle = this.showsGenericDevices
      ? this.$t("assignDevice.genericAssignmentHintTitle")
      : this.$t("assignDevice.assignmentHintTitle");

    return `${hintTitle} (${filterText})`;
  }

  subscriptions: Array<() => void> = [];

  isObservingClientPanelAssignments = false;
  isObservingGenericDeviceAssignments = false;
  isObservingProject = false;
  isObservingProjectMetaData = false;
  isObservingReports = false;
  isObservingMeasurmentProtocolData = false;
  isObservingProjectNotes = false;
  isObservingProjectStatus = false;
  isObservingProjectLogs = false;
  isObservingProjectSyncedNotes = false;

  clientPanelAssignments: Array<ClientPanelAssignment> = [];
  genericDeviceAssignments: Array<GenericDeviceProjectAssignment> = [];
  reports: Array<Report> = [];
  measurementProtocolData: Array<MeasurementProtocolData> = [];
  projectNotes: Array<ProjectNote> = [];

  isProcessingProject = false;
  isSavingProject = false;
  isLoadingProject = false;

  updatedProjectDetails = false;

  projectNotFound = false;

  get activeUser() {
    return getActiveUser();
  }

  get areAllAssignmentsClosed() {
    const areAllClientPanelAssignmentsClosed = !this.clientPanelAssignments.some(
      assignment => !assignment.assignmentEndDate
    );
    const areAllGenericDeviceAssignmentsClosed = !this.genericDeviceAssignments.some(
      assignment => !assignment.assignmentEndDate
    );

    return areAllClientPanelAssignmentsClosed && areAllGenericDeviceAssignmentsClosed;
  }

  get earliestAssignmentDate(): firestore.Timestamp | null {
    const allAssignments = [
      ...this.clientPanelAssignments,
      ...this.genericDeviceAssignments,
    ];

    if (allAssignments.length === 0) {
      return null;
    }

    return allAssignments.reduce<firestore.Timestamp | null>((earliest, assignment) => {
      if (!earliest) return assignment.assignmentStartDate;
      return assignment.assignmentStartDate.toMillis() < earliest.toMillis()
        ? assignment.assignmentStartDate
        : earliest;
    }, null);
  }

  get isAlwaysAllowedToEditDeviceAssignments() {
    return alwaysAllowedToEditDeviceAssignmentsAccess(this.activeUser);
  }

  get filteredIresDeviceAssisgnments() {
    const filter = this.selectedFilter;
    return this.clientPanelAssignments.filter(
      (assignment) =>
        filter === AssignmentFilter.ALL || !assignment.assignmentEndDate
    );
  }

  /**
   * The generic assignments the devices tab shows: all of them with "Alle Geräte verwalten" on,
   * only the open ones with it off (see {@link isGenericDeviceAssignmentShown}).
   */
  get shownGenericDeviceAssignments() {
    const hasAllDevicesManagementAccess = this.hasAllDevicesManagementAccess;

    return this.genericDeviceAssignments.filter(
      (assignment) => isGenericDeviceAssignmentShown(assignment, hasAllDevicesManagementAccess)
    );
  }

  /** Whether the devices tab lists generic devices, which decides its "HyDry" or general wording. */
  get showsGenericDevices() {
    return this.hasAllDevicesManagementAccess || this.shownGenericDeviceAssignments.length > 0;
  }

  get filteredGenericDeviceAssisgnments() {
    const filter = this.selectedFilter;
    return this.shownGenericDeviceAssignments.filter(
      (assignment) =>
        filter === AssignmentFilter.ALL || !assignment.assignmentEndDate
    );
  }

  /**
   * Reports grouped into generation runs, newest run first, each run led by its
   * internal report so the report list's indentation reads as a hierarchy.
   * See `groupAndSortReports`.
   */
  get sortedReports() {
    return groupAndSortReports(this.reports);
  }

  get canDeleteProject() {
    return (
      !this.isNewProject &&
      this.areAllAssignmentsClosed && 
      deleteProjectAccess(
        getActiveUser()
      )
    );
  }

  /**
   * The selected tab: the app bar colour in both themes (COLOR_PRIMARY / COLOR_APP_BAR_DARK). The
   * Vuetify underline takes the same colour (`slider-color`), so, as in light mode, it never shows
   * as a line of its own.
   */
  get activeTabColor() {
    return themed(COLOR_PROJECT_DETAILS_SELECTED_TAB, COLOR_APP_BAR_DARK);
  }

  get hasAllDevicesManagementAccess() {
    return manageAllDevicesClientAccess();
  }

  get hasEditProjectAccess() {
    return editProjectAccess(this.activeUser);
  }

  get hasReopenProjectPhasesAccess() {
    return reopenProjectAccess(this.activeUser);
  }

  get hasMoveProjectAccess() {
    return moveProjectAccess(this.activeUser);
  }

  get isPortalOnlyProject() {
    return isPortalOnlyProject(this.projectDetails);
  }

  /** True when the project is portal-only and the drying workflow (step 10 or 14) has started but is not yet complete. */
  get isDryingWorkflowInProgress() {
    if (!this.isPortalOnlyProject) return false;
    const dryingWorkflowStarted = hasStepStarted(this.projectStatus?.projectSteps["10"])
      || hasStepStarted(this.projectStatus?.projectSteps["14"]);
    const dryingWorkflowComplete = !!this.projectStatus?.projectSteps["15"];
    return dryingWorkflowStarted && !dryingWorkflowComplete;
  }

  get isRestoredProject() {
    return this.projectDetails.conclusion?.conclusionState === ProjectConclusionState.RESTORED;
  }

  get showDeleteProjectButton() {
    if (this.projectNotFound) {
      return false;
    }

    return (
      this.canDeleteProject &&
      this.selectedTab === ProjectDetailsTab.CLIENT_DATA
    );
  }

  get showMoveProjectButton() {
    return shouldShowMoveOrReopenProjectFab({
      projectNotFound: this.projectNotFound,
      isNewProject: this.isNewProject,
      selectedTab: this.selectedTab,
      isReadOnlyMode: this.isReadOnlyMode,
      hasReopenProjectPhasesAccess: this.hasReopenProjectPhasesAccess,
      canFinaliseProjectInOffice: this.canFinaliseProjectInOffice,
      hasMoveProjectAccess: this.hasMoveProjectAccess,
      areAllAssignmentsClosed: this.areAllAssignmentsClosed,
    });
  }

  get projectManagementSettings() {
    return ProjectManagementSettingsModule.projectManagementSettings;
  }

  get projectSettings() {
    return getProjectSettingsV2(this.projectManagementSettings);
  }

  get canEditProject() {
    if (this.isReadOnlyMode) {
      return false;
    }

    // TODO: Remove this
    /* if (this.projectDetails.projectImportSource) {
      if (getErpIntegration() !== ErpIntegration.NONE) {
        return false;
      }
    } */

    return this.hasEditProjectAccess;
  }

  get canFinaliseProjectInPortal() {
    return this.projectSettings.finaliseProjectsIn.includes(ProjectSettingsOptions.PORTAL);
  }

  get canFinaliseProjectInOffice() {
    return this.projectSettings.finaliseProjectsIn.includes(ProjectSettingsOptions.PORTAL);
  }

  get canEditAssignments() {
    if (this.isAlwaysAllowedToEditDeviceAssignments) {
      return true;
    }

    if (!this.canEditProject) {
      return false;
    }

    if (this.projectDetails.projectConclusionData?.projectConclusionDate) {
      return false;
    }

    const baseAllowed = this.isProjectWebsiteOnly || !this.doesClientHaveApp;
    if (!baseAllowed) {
      return false;
    }

    return this.isDeviceAssignmentInAllowedProjectState;
  }

  /**
   * Checks whether the current project state allows device assignment.
   * 
   * Portal-only projects: allowed from step 9 "Freigabe Trocknung" to before step 18 "Projekt abgeschlossen".
   * Non-portal projects: allowed from step 6 "Beginn Schadenaufnahme" to before step 15 "Abschluss Trocknung".
   * 
   * Handles phase reopening (state adjusts back), suspension (state unchanged, assignment still allowed),
   * and resuming (state unchanged, assignment still allowed).
   */
  get isDeviceAssignmentInAllowedProjectState(): boolean {
    if (!this.projectOverview) {
      return false;
    }

    return isDeviceAssignmentAllowedByProjectState(
      this.projectOverview,
      new Date(),
    );
  }

  get setupDevicesData() {
    return this.projectDetails.setupDevicesData;
  }

  get contactPersons() {
    const apartmentsForElectricityBilling = mapApartmentsForElectricityBillingToContactPersons(
      this.setupDevicesData?.apartmentsForElectricityBilling ?? []
    );

    return [
      ...this.projectDetails.clientData.contactPersons,
      ...apartmentsForElectricityBilling
    ];
  }

  get showApartmentNames() {
    return this.contactPersons.length > 1;
  }

  observeProjectDocument(projectId: string) {
    if (this.isObservingProject) {
      return;
    }

    this.isObservingProject = true;
    this.subscriptions.push(
      observeProject(
        projectId,
        (projectDetails: ProjectDetails) => {
          if (this.isNewProject || this.isSavingProject) {
            return;
          }

          this.projectDetails = projectDetails;
          this.lastProjectLoadTimestamp = new Date();
        }
      )
    );
  }

  observeProjectMetaData(projectId: string) {
    if (this.isObservingProjectMetaData) {
      return;
    }

    this.isObservingProjectMetaData = true;
    this.subscriptions.push(
      observeProjectMetaData(
        projectId,
        async (projectMetaData: ProjectMetaData) => {
          const lastChangeToSync = projectMetaData?.lastChangeToSync;

          if (lastChangeToSync) {
            if (
              lastChangeToSync.changedBy !== "WEB" ||
              lastChangeToSync.changeSourceClientId !== getClientId()
            ) {
              if (
                !this.lastProjectLoadTimestamp ||
                lastChangeToSync.changeTimestamp.toDate().getTime() >
                  this.lastProjectLoadTimestamp.getTime()
              ) {
                await this.loadProjectDetails(projectId);
              }
            }
          } else if (
            !this.projectDetails.clientData.projectNumber &&
            projectMetaData?.projectNumberErp
          ) {
            const update = clone(this.projectDetails);

            update.clientData.projectNumber = projectMetaData.projectNumberErp;

            this.projectDetails = update;
          }
        }
      )
    );
  }

  observeClientPanelAssignments(projectId: string) {
    if (this.isObservingClientPanelAssignments) {
      return;
    }

    this.isObservingClientPanelAssignments = true;

    this.subscriptions.push(
      observeClientPanelAssignmentsOfProject(
        projectId,
        (clientPanelAssignments: Array<ClientPanelAssignment>) => {
          this.clientPanelAssignments = clientPanelAssignments.sort(
            (c1, c2) => c1.assignmentIndex - c2.assignmentIndex
          );
        }
      )
    );
  }

  observeGenericDeviceAssignments(projectId: string) {
    if (this.isObservingGenericDeviceAssignments) {
      return;
    }

    this.isObservingGenericDeviceAssignments = true;

    this.subscriptions.push(
      observeGenericDeviceAssignmentsOfProject(
        projectId,
        (genericDeviceAssignments: Array<GenericDeviceProjectAssignment>) => {
          this.genericDeviceAssignments = genericDeviceAssignments.sort(
            (c1, c2) => c1.assignmentIndex - c2.assignmentIndex
          );
        }
      )
    );
  }

  observeProjectStatus(projectId: string) {
    if (this.isObservingProjectStatus) {
      return;
    }

    this.isObservingProjectStatus = true;

    this.subscriptions.push(
      observeProjectStatus(projectId, (projectStatus) => {
        this.projectStatus = projectStatus;
      })
    );
  }

  observeProjectLogs(projectId: string) {
    if (this.isObservingProjectLogs) {
      return;
    }

    this.isObservingProjectLogs = true;

    this.subscriptions.push(
      observeProjectLogs(projectId, (projectLogs) => {
        this.projectLogs = projectLogs;
      })
    );
  }

  observeProjectSyncedNotes(projectId: string) {
    if (this.isObservingProjectSyncedNotes) {
      return;
    }

    this.isObservingProjectSyncedNotes = true;

    this.subscriptions.push(
      observeProjectSyncedNotes(projectId, (projectSyncedNotes) => {
        this.projectSyncedNotes = projectSyncedNotes;
      })
    );
  }

  observeProjectNotes(projectId: string) {
    if (this.isObservingProjectNotes) {
      return;
    }

    this.isObservingProjectNotes = true;

    this.subscriptions.push(
      observeNotesOfProject(
        projectId,
        (projectNotes: ProjectNote[]) => (this.projectNotes = projectNotes)
      )
    );
  }

  observeMeasurementProtocolData(projectId: string) {
    if (this.isObservingMeasurmentProtocolData) {
      return;
    }

    this.isObservingMeasurmentProtocolData = true;

    this.subscriptions.push(
      observeMeasurementProtocolData(
        projectId,
        (measurementProtocolData: Array<MeasurementProtocolData>) => {
          this.measurementProtocolData = measurementProtocolData;
        }
      )
    );
  }

  observeReports(projectId: string) {
    if (this.isObservingReports) {
      return;
    }

    this.isObservingReports = true;

    this.subscriptions.push(
      observeReportsOfProject(
        projectId,
        (reports: Array<Report>) => {
          this.reports = reports
        }
      )
    );
  }

  showErrorSnackbar(
    message: string,
    ...parameters: string[]
  ) {
    SnackbarModule.showError({ key: message, params: parameters });
  }

  showSuccessSnackbar(
    message: string, 
    ...parameters: string[]
  ) {
    SnackbarModule.showSuccess({ key: message, params: parameters });
  }

  private isResyncingTab = false;

  get tabModel(): number {
    return this.selectedTab;
  }

  set tabModel(val: number) {
    if (val === this.selectedTab || this.isResyncingTab) return;
    if (this.pdeViewerReport) {
      this.handleViewerTabSwitch(val, "pdeViewer", "pdeViewerReport");
      return;
    }
    if (this.beschreibungViewerReport) {
      this.handleViewerTabSwitch(val, "beschreibungViewer", "beschreibungViewerReport");
      return;
    }
    this.selectedTab = val;
  }

  private async handleViewerTabSwitch(
    newTab: number,
    viewerRef: string,
    reportField: "pdeViewerReport" | "beschreibungViewerReport"
  ) {
    const viewer = this.$refs[viewerRef] as { hasUnsavedChanges?: boolean } | undefined;
    if (viewer?.hasUnsavedChanges) {
      const discard = await this.confirmationDialogComponent.show({
        title: this.$t("common.confirmationDialog.cancelTitle").toString(),
        message: this.$t("common.confirmationDialog.cancelMessage").toString(),
      });
      if (!discard) {
        // Force v-tabs to re-sync its internal highlight with our value
        this.isResyncingTab = true;
        const current = this.selectedTab;
        this.selectedTab = -1 as unknown as ProjectDetailsTab;
        this.$nextTick(() => {
          this.selectedTab = current;
          this.$nextTick(() => { this.isResyncingTab = false; });
        });
        return;
      }
    }
    this[reportField] = null;
    this.selectedTab = newTab;
  }

  @Watch("hasAllDevicesManagementAccess")
  async onHasAllDevicesManagementAccessChanged() {
    const projectId = this.projectDetails.id;

    if (projectId) {
      this.observeGenericDeviceAssignments(projectId);
    }
    else {
      this.isObservingGenericDeviceAssignments = false;
    }
  }

  @Watch("projectDetails")
  async onProjectChanged(after: ProjectDetails) {
    this.updateToolbarTitle(after);
    this.recalculateTabsPreservingSelection();
  }

  /**
   * Recalculates the tabs array while preserving the currently selected tab type.
   * Guards against Vuetify's spurious v-model updates during re-render.
   */
  private recalculateTabsPreservingSelection(addReportsTab = true) {
    const currentTabType = this.tabs[this.selectedTab];
    const newTabs = this.calculateTabs(addReportsTab);

    let newIndex = 0;
    if (currentTabType !== undefined) {
      const idx = newTabs.indexOf(currentTabType);
      if (idx !== -1) {
        newIndex = idx;
      }
    }

    this.isResyncingTab = true;
    this.tabs = newTabs;
    this.selectedTab = newIndex;
    this.$nextTick(() => {
      this.isResyncingTab = false;
    });
  }

  @Watch("projectStatus")
  async onProjectStatusChanged() {
    if (this.updatedProjectDetails) {
      await this.loadProjectDetails(this.projectDetails.id);
      this.updatedProjectDetails = false;
    }
  }

  @Watch("$route", { immediate: true, deep: true })
  onUrlChange() {
    this.updateToolbarTitle(this.projectDetails);

    const projectId = router.currentRoute.params["projectId"];

    if (!projectId) {
      return;
    }

    this.observeProjectDocument(projectId);
    this.observeProjectStatus(projectId);
    this.observeProjectLogs(projectId);
    this.observeProjectSyncedNotes(projectId);
    this.observeReports(projectId);
    //this.observeMeasurementProtocolData(projectId);
    this.observeProjectNotes(projectId);
    this.observeClientPanelAssignments(projectId);
    this.observeProjectMetaData(projectId);
    this.observeGenericDeviceAssignments(projectId);
  }

  @Watch("clientPanelsToBeReleased")
  onClientPanelsToBeReleasedChanged(
    after: PanelsToBeReleased[]
  ) {
    if (this.noOfClientPanelsToBeReleased > after.length && after.length > 0) {
      const clientPanelToBeReleased = after[0];

      this.onEditAssignment(
        clientPanelToBeReleased.clientPanelAssignment,
        clientPanelToBeReleased.clientPanel,
        clientPanelToBeReleased.contactPersonInfo,
        true
      );
      this.noOfClientPanelsToBeReleased--;
    }
  }
  
  updateToolbarTitle(projectDetails: ProjectDetails) {
    let toolbarTitle = this.$t("pages.projectDetails").toString();

    if (isSimulatingErp() && projectDetails.clientData.projectNumberIres) {
      toolbarTitle += ` "${projectDetails.clientData.projectNumberIres.trim()}"`;
    }
    else if (projectDetails.clientData.projectName) {
      toolbarTitle += ` "${projectDetails.clientData.projectName.trim()}"`;
    }

    ToolbarContentModule.setToolbarTitle(toolbarTitle);
  }

  isTabDisabled() {
    return (
      this.isNewProject && !this.isTabSelected(ProjectDetailsTab.CLIENT_DATA)
    );
  }

  showDevices() {
    return this.isTabSelected(ProjectDetailsTab.DEVICES);
  }

  showCoreData() {
    return this.isTabSelected(ProjectDetailsTab.CLIENT_DATA);
  }

  showProjectStatus() {
    return this.isTabSelected(ProjectDetailsTab.STATUS);
  }

  showLogBoook() {
    return this.isTabSelected(ProjectDetailsTab.LOGBOOK);
  }

  showConcludeProject() {
    return this.isTabSelected(ProjectDetailsTab.CONCLUDE_PROJECT);
  }

  showReports() {
    return this.isTabSelected(ProjectDetailsTab.REPORTS);
  }

  onOpenPdeViewer(report: Report) {
    this.pdeViewerReport = report;
  }

  onClosePdeViewer() {
    this.pdeViewerReport = null;
  }

  onOpenBeschreibungViewer(report: Report) {
    this.beschreibungViewerReport = report;
  }

  onCloseBeschreibungViewer() {
    this.beschreibungViewerReport = null;
  }

  showNotesTab() {
    return this.isTabSelected(ProjectDetailsTab.NOTES);
  }

  showDocumentsTab() {
    return this.isTabSelected(ProjectDetailsTab.DOCUMENTS);
  }

  isTabSelected(tab: ProjectDetailsTab) {
    return tab === this.tabs[this.selectedTab];
  }

  /** The desktop tab label: the title, with the count in brackets where the tab has one. */
  getTabName(tab: ProjectDetailsTab) {
    const count = this.getTabCount(tab);
    return count ? `${this.getTabTitle(tab)} (${count})` : this.getTabTitle(tab);
  }

  getTabTitle(tab: ProjectDetailsTab) {
    switch (tab) {
      case ProjectDetailsTab.DOCUMENTS:
        return this.$t("projectDetails.documents").toString();
      case ProjectDetailsTab.DEVICES: {
        const titleKey = this.deviceTabCount.hasActiveDevices
          ? (this.showsGenericDevices ? "common.activeDevices" : "common.activeHydryDevices")
          : (this.showsGenericDevices ? "common.allDevices" : "common.hydryDevices");
        return this.$t(titleKey).toString();
      }
      case ProjectDetailsTab.STATUS:
        return this.$t("projectDetails.timeLine").toString();
      case ProjectDetailsTab.LOGBOOK:
        return this.$t("projectDetails.logBook").toString();
      case ProjectDetailsTab.CLIENT_DATA:
        return this.$t("projectDetails.project").toString();
      case ProjectDetailsTab.NOTES:
        return this.$t("projectDetails.notes").toString();
      case ProjectDetailsTab.CONCLUDE_PROJECT:
        return this.$t("projectDetails.projectConclusion").toString();
      case ProjectDetailsTab.REPORTS:
        return this.$t("projectDetails.reports").toString();
    }
  }

  /** The count a tab carries ("6", "1/3" for active of all devices, "12" reports), or null. */
  getTabCount(tab: ProjectDetailsTab): string | null {
    switch (tab) {
      case ProjectDetailsTab.DEVICES:
        return this.deviceTabCount.count;
      case ProjectDetailsTab.REPORTS:
        return this.reports.length.toString();
      default:
        return null;
    }
  }

  get deviceTabCount() {
    const countPanels = (assignments: ClientPanelAssignment[]) =>
      filterUniqueByField(assignments, "serialNumber").length;
    const countGenericDevices = (assignments: GenericDeviceProjectAssignment[]) =>
      filterUniqueByField(assignments, "assignedDeviceId").length;

    // Same wording rule as the project list rows. Unlike the list, the
    // screen holds every assignment, ended ones included, so the total is
    // counted here rather than read from the overview entry.
    return getDeviceTabCount(getDeviceCountInfo({
      numDevices:
        countPanels(this.clientPanelAssignments.filter(a => !a.assignmentEndDate)) +
        countGenericDevices(this.shownGenericDeviceAssignments.filter(a => !a.assignmentEndDate)),
      numDevicesTotal:
        countPanels(this.clientPanelAssignments) +
        countGenericDevices(this.shownGenericDeviceAssignments),
    }));
  }

  /** The phone tab bar's label: the title, shortened where a tab's title does not fit an item. */
  getTabShortTitle(tab: ProjectDetailsTab) {
    switch (tab) {
      case ProjectDetailsTab.DEVICES:
        return this.$t("common.devices").toString();
      case ProjectDetailsTab.CONCLUDE_PROJECT:
        return this.$t("projectDetails.projectConclusionShort").toString();
      default:
        return this.getTabTitle(tab);
    }
  }

  /** A count badge on the phone tab item, left out at zero as a tab bar badge is. */
  hasPhoneTabBadge(tab: ProjectDetailsTab) {
    const count = this.getTabCount(tab);
    return !!count && count !== "0";
  }

  getTabIcon(tab: ProjectDetailsTab) {
    return PROJECT_DETAILS_TAB_ICONS[tab];
  }

  get phoneTabs() {
    return splitPhoneTabs(this.tabs);
  }

  isPhoneTabSelected(tab: ProjectDetailsTab) {
    return this.tabs[this.selectedTab] === tab;
  }

  get isOverflowTabSelected() {
    return this.phoneTabs.overflow.includes(this.tabs[this.selectedTab]);
  }

  /**
   * Position of the sliding indicator: the selected item, or "Mehr" while one of its tabs is
   * open. The items share the bar equally, so a width and a translation place it.
   */
  get phoneTabIndicatorStyle() {
    const selected = this.tabs[this.selectedTab];
    const itemCount = this.phoneTabs.visible.length + (this.phoneTabs.overflow.length > 0 ? 1 : 0);
    const index = this.isOverflowTabSelected
      ? this.phoneTabs.visible.length
      : this.phoneTabs.visible.indexOf(selected);

    if (index < 0 || itemCount === 0) {
      return null;
    }

    return { width: `${100 / itemCount}%`, transform: `translateX(${index * 100}%)` };
  }

  /** Goes through tabModel, so the PDE / Beschreibung viewer handling of a tab switch still applies. */
  selectPhoneTab(tab: ProjectDetailsTab) {
    this.tabModel = this.tabs.indexOf(tab);
  }

  async mounted() {
    const projectId = router.currentRoute.params["projectId"];

    if (projectId) {
      let foundCachedProjectDetails = false;
      const cachedProjectDetails = ProjectDetailsModule.projectDetailsState;

      if (
        cachedProjectDetails &&
        cachedProjectDetails.projectDetails.id === projectId
      ) {
        foundCachedProjectDetails = true;
        this.projectDetails = cachedProjectDetails.projectDetails;
        this.clientPanelAssignments =
          cachedProjectDetails.clientPanelAssignments;
        this.genericDeviceAssignments =
          cachedProjectDetails.genericDeviceAssignments;
        this.reports = cachedProjectDetails.reports;
        this.selectedTab = cachedProjectDetails.projectDetailsTab;
        this.areProjectDetailsLoaded = true;
      }

      this.isNewProject = false;
      this.isLoadingProject = !foundCachedProjectDetails;

      //Always load project details, even if we found a cached state
      await this.loadProjectDetails(projectId);

      this.tabs = this.calculateTabs();

      if (
        router.currentRoute.query["openDevices"] === "1" ||
        getBoolean("KEY_OPEN_DEVICES_TAB")
      ) {
        setBoolean("KEY_OPEN_DEVICES_TAB", null);
        this.selectedTab = this.tabs.indexOf(ProjectDetailsTab.DEVICES);
      } else if (getBoolean("KEY_OPEN_CONCLUSION_TAB")) {
        setBoolean("KEY_OPEN_CONCLUSION_TAB", null);
        this.selectedTab = this.tabs.indexOf(
          ProjectDetailsTab.CONCLUDE_PROJECT
        );
      }

      this.isLoadingProject = false;
    } else {
      const directOrder = router.currentRoute.query["directOrder"] === "1";
      
      if (this.tabs.length === 0) {
        this.tabs = [ProjectDetailsTab.CLIENT_DATA];
      }

      const newProjectScope = 
        getProjectManagementType() === ProjectManagement.PROJECT_OPTION ? 
        NewProjectScope.FLEX :
        router.currentRoute.query[
          "newProjectScope"
        ] as NewProjectScope;  

      this.projectDetails = createNewProject(newProjectScope, directOrder);
      this.isNewProject = true;
    }

    this.initialProjectApproval = this.projectDetails.clientData.projectApproval;
    this.areProjectDetailsLoaded = true;
  }

  get canRestoreProjects() {
    return restoreProjectAccess(this.activeUser)
  }

  async loadProjectDetails(projectId: string) {
    const projectDetails = await getProjectDetails(projectId);

    if (projectDetails === ProjectRetrievalErrorState.PROJECT_IS_ARCHIVED) {
      if (!this.canRestoreProjects) {
        this.tabs = this.calculateTabs();
        this.projectNotFound = true;

        return; 
      }

      const result = await this.confirmationDialogComponent.show({
        title: this.$t("archivedProjects.restorationConfirmationDialog.titleAlt").toString(),
        message: this.$t("archivedProjects.restorationConfirmationDialog.messageAlt").toString(),
        acceptMessage: this.$t("common.restore").toString(),
        rejectMessage: this.$t("common.back").toString()
      });

      if (result) {
        await restoreProject(projectId);
        
        router.go(1);
      }
      else {
        router.back();
      }

      return;
    }
    else if (projectDetails === ProjectRetrievalErrorState.PROJECT_DOES_NOT_EXIST) {      
      this.tabs = this.calculateTabs();
      this.projectNotFound = true;
      return;
    }

    if (!this.lastProjectLoadTimestamp) {
      this.lastProjectLoadTimestamp = new Date();
    }

    this.projectOverview = await getProjectOverview(projectDetails, { isProjectFinished: isProjectFinished(projectDetails) });
    this.projectDetails = projectDetails;
    this.isNewProject = false;
  }

  /**
   * Replaces a confirmation message with the running-task warning when somebody is still working
   * on this project. Deleting it or moving it to the finished projects makes the Cloud close those
   * tasks (the project would otherwise leave its owner permanently "busy" in IRES Work), so the
   * user has to see that the operation interrupts someone: who is working, on which task, followed
   * by the short confirmation question of the operation (`questionKey`). Silent on failure: a
   * probe must never keep the user from deleting or moving the project.
   */
  async withRunningTaskWarning(message: string, questionKey: string): Promise<string> {
    // Gated exactly like the stale-close dialog in `Scaffold.checkAndHandleStaleOpenEntry`: this text is
    // time-tracking UI, so it needs the feature to be on for the client AND the IRES pre-release
    // capability, or a client would meet an unreleased feature the moment one of their users left a task
    // running. Checked before the read as well as before the text, so an ordinary delete costs nothing.
    if (
      !manageTimeTrackingClientAccess() ||
      !alwaysAllowedToViewTimeTrackingAccess(getActiveUser())
    ) {
      return message;
    }

    try {
      const openLogs = await getOpenProjectTimeTrackingLogs(this.projectDetails.id);

      if (openLogs.length === 0) {
        return message;
      }

      // A shared (team) task lists every involved user in `additionalUsers`, so all of them are
      // named with that task — closing it ends the task for the whole team.
      const workers = [
        ...new Set(
          openLogs.flatMap((log) => {
            const task = this.$t(getProjectLogTaskLabel(log)).toString();

            return [log.startedByUserId, ...(log.additionalUsers ?? [])]
              .map((userId) => findNickname(userId))
              .filter((name): name is string => !!name)
              .map((name) => `${name}: ${task}`);
          })
        )
      ];

      // No name resolved (a deleted user, say): the warning would read as an empty bracket, so
      // keep the plain confirmation message instead.
      if (workers.length === 0) {
        return message;
      }

      return `${this.$tc(
        "clientData.runningTasksSuspensionWarning",
        openLogs.length,
        [workers.join(", ")]
      )}\n${this.$t(questionKey)}`;
    }
    catch {
      return message;
    }
  }

  async onDeleteProject() {
    const projectName = this.projectDetails.clientData.projectName?.trim()
      ?? this.projectDetails.clientData.projectNumber;

    const response = await this.confirmationDialogComponent.show({
      title: this.$t("clientData.deleteProjectTitle", [projectName]).toString(),
      message: await this.withRunningTaskWarning(
        this.$t("clientData.deleteProjectMessage").toString(),
        "clientData.runningTasksSuspensionDeleteQuestion"
      ),
      rejectMessage: this.$t("common.back").toString(),
      acceptMessage: this.$t("common.delete").toString()
    });

    const cockpitCardType = this.cockpitCardType;
    const ignoreUserRequirements = this.ignoreUserRequirements;
    const sortOrder = this.sortOrder;

    const isProjectsTab = this.isProjectsTab;

    if (response) {
      this.isProcessingProject = true;
      const result = await deleteProject(this.projectDetails.id);
      this.isProcessingProject = false;

      if (result) {
        setString("KEY_DELETED_PROJECT_NAME", projectName);

        if (isProjectsTab === "true") {
          router.replace({ 
          path: `/main/projects`
        });
        }
        else {
          router.replace({ 
            path: `/main/cockpit/projects`,
            query: {
              cockpitCardType: cockpitCardType?.toString(),
              ignoreUserRequirements: ignoreUserRequirements
                ? ignoreUserRequirements.toString()
                : null,
              sortOrder: (
                sortOrder ?? ProjectSortOrder.NEWEST_FIRST
              ).toString(),
              isProjectsTab: "false"
            }
          });
        }
      }
      else {
        this.showErrorSnackbar("clientData.deleteProjectErrorMessage", projectName);
      }
    }
  }

  calculateReopenProjectDialogTitle(projectName: string) {
    const isProjectFinished = this.isProjectFinished;

    return isProjectFinished 
      ? this.$t("clientData.moveProjectToRunningDialog.title", [projectName]).toString()
      : this.$t("clientData.moveProjectToRunningDialog.titleAlt", [projectName]).toString()
  }

  calculateReopenProjectDialogMessage() {
    const isRestoredProject = this.isRestoredProject;
    const isProjectFinished = this.isProjectFinished;

    if (isRestoredProject) {
      return isProjectFinished 
        ? this.$t("clientData.moveProjectToRunningDialog.messageForRestoredProjects").toString()
        : this.$t("clientData.moveProjectToRunningDialog.messageForRestoredProjectsAlt").toString()
    }

    return isProjectFinished 
      ? this.$t("clientData.moveProjectToRunningDialog.message").toString()
      : this.$t("clientData.moveProjectToRunningDialog.messageAlt").toString()
  }

  calculateReopenProjectDialogAcceptMessage() {
    const isProjectFinished = this.isProjectFinished;

    return isProjectFinished 
      ? this.$t("clientData.moveProjectToRunningDialog.acceptButtonText").toString()
      : this.$t("clientData.moveProjectToRunningDialog.acceptButtonTextAlt").toString()
  }

  async onMoveProject() {
    const projectName = this.projectDetails.clientData.projectName?.trim()
      ?? this.projectDetails.clientData.projectNumber;

    if (this.isReadOnlyMode) {
      const response = await this.confirmationDialogComponent.show({
        title: this.calculateReopenProjectDialogTitle(projectName),
        message: this.calculateReopenProjectDialogMessage(),
        rejectMessage: this.$t("common.back").toString(),
        acceptMessage: this.calculateReopenProjectDialogAcceptMessage()
      });

      if (response) {
        this.isProcessingProject = true;
        const wasProjectFinishedBefore = this.isProjectFinished;

        const update = await reopenProject(
          this.projectDetails, 
          { isProjectFinished: this.isReadOnlyMode },
          !wasProjectFinishedBefore
        );
        this.isProcessingProject = false;

        if (update) {
          this.onProjectReopened(update);
          this.showSuccessSnackbar(`clientData.moveProjectToRunningDialog.${wasProjectFinishedBefore
              ? "successMessage"
              : "successMessageAlt"
            }`, projectName);
        }
        else {
          this.showErrorSnackbar(`clientData.moveProjectToRunningDialog.${wasProjectFinishedBefore
              ? "errorMessage"
              : "errorMessageAlt"
            }`, projectName);
        }
      }
    }
    else {
      const response = await this.confirmationDialogComponent.show({
        title: this.$t("clientData.moveProjectToFinishedDialog.title", [projectName]).toString(),
        message: await this.withRunningTaskWarning(
          this.$t("clientData.moveProjectToFinishedDialog.message").toString(),
          "clientData.runningTasksSuspensionMoveToFinishedQuestion"
        ),
        rejectMessage: this.$t("common.back").toString(),
        acceptMessage: this.$t("common.moveToFinished").toString()
      });

      if (response) {
        this.isProcessingProject = true;
        const result = await moveProjectToFinished(this.projectDetails.id);

        if (result) {
          await this.loadProjectDetails(this.projectDetails.id);
          this.isProcessingProject = false;

          this.showSuccessSnackbar("clientData.moveProjectToFinishedDialog.successMessage", projectName);
        }
        else {
          this.isProcessingProject = false;
          this.showErrorSnackbar("clientData.moveProjectToFinishedDialog.errorMessage", projectName);
        }

      }
    }

    this.recalculateTabsPreservingSelection();
  }

  async onProjectOwnershipChanged(
    projectOwnershipUpdate: ProjectOwnershipUpdate
  ) {
    this.isSavingProject = true;

    const { result, data } = await setProjectOwnership(
      this.projectDetails,
      projectOwnershipUpdate.newOwnerId,
      projectOwnershipUpdate.newSupervisorId,
      projectOwnershipUpdate.newOwnerStaffNumber,
      projectOwnershipUpdate.newSupervisorStaffNumber,
      getRecordInfo().recordedByUserId
    );

    this.isSavingProject = false;

    if (result === ProjectSaveResult.PROJECT_SAVED) {
      this.projectOverview = await getProjectOverview(data, { isProjectFinished: isProjectFinished(data) });
      this.projectDetails = clone(data);
    }
  }

  async onSaveProjectDetails(toSave: ProjectDetails) {
    this.isSavingProject = true;

    const { result, data } = await saveProject(
      this.projectDetails,
      this.isNewProject,
      this.isApprovalDecisionChanged,
      this.updateRoomsData
    );

    this.isSavingProject = false;

    if (result === ProjectSaveResult.PROJECT_SAVED) {
      this.showSuccessSnackbar("common.dataSaved");

      if (this.isNewProject) {
        this.projectDetails = clone(data);
        this.skipedFirstProjectChange = true;
        this.isNewProject = false;
        this.updateRoomsData = false;

        router.replace({ path: `projects/${toSave.id}` });
      }
    } else {
      this.showErrorSnackbar("clientData.saveProjectErrorMessage");
    }

    const portalProjectBefore = this.tabs.includes(2);
    const portalProjectAfter = this.calculateTabs().includes(2);

    if (
      portalProjectBefore !==  portalProjectAfter &&
      portalProjectBefore === false
    ) {
      this.recalculateTabsPreservingSelection(false);
      setTimeout(() => this.tabs.push(ProjectDetailsTab.REPORTS), 10);
    }
    else {
      this.recalculateTabsPreservingSelection();
    }
  }

  async deleteContactPerson(toDelete: ContactPersonInfo) {
    const hasClientPanelAssignments = this.clientPanelAssignments.some(
      (c) => c.contactPersonId === toDelete.id
    );
    const hasGenericAssignments = this.genericDeviceAssignments.some(
      (g) => g.contactPersonId === toDelete.id
    );

    if (hasClientPanelAssignments || hasGenericAssignments) {
      this.showErrorSnackbar(
        "clientData.deleteContactPersonBlockedByDevices",
        String(toDelete.contactPersonNumber)
      );
      return;
    }

    const assignmentsOfContactPerson = this.clientPanelAssignments.filter(
      (c) => c.contactPersonId === toDelete.id
    );

    this.isSavingProject = true;

    this.projectDetails.clientData.contactPersons = this.projectDetails.clientData.contactPersons.filter(
      (contactPersonInfo) => contactPersonInfo.id !== toDelete.id
    );

    if (this.projectDetails.damagePatternData?.rooms) {
      this.projectDetails.damagePatternData.rooms = this.projectDetails.damagePatternData.rooms.filter(
        (room) => room.contactPersonId !== toDelete.id
      );

      this.updateRoomsData = true;
    }
    

    // Move all devices assigned to Flat X to Flat 1 when Flat X is being deleted.
    await updateContactPersonOfClientPanelAssignments(
      toDelete.contactPersonNumber,
      this.projectDetails.clientData.contactPersons[0].id,
      assignmentsOfContactPerson,
      this.projectDetails.id,
      isPortalOnlyProject(this.projectDetails),
      this.projectDetails.syncTarget
    );
    
    this.projectDetails = clone(this.projectDetails);
    this.onSaveProjectDetails(this.projectDetails);

    const info: ContactPersonEventInfo = { contactPersonNumber: toDelete.contactPersonNumber };
    const eventLog = createProjectEventLog(
      ProjectEventType.CONTACT_PERSON_DELETED,
      getRecordInfo(),
      JSON.stringify(info)
    );
    addProjectEventLog(this.projectDetails.id, eventLog);
  }

  async onAssignPanelsToFirstContactPerson() {
    return this.onAssignIresDevicesToContactPerson(
      this.projectDetails.clientData.contactPersons[0]
    );
  }

  onProjectReopened(reopenedProject: ProjectDetails) {
    this.projectDetails = reopenedProject;
    
    const projectName = this.projectDetails.clientData.projectName?.trim()
      ?? this.projectDetails.clientData.projectNumber;

    this.showSuccessSnackbar(`clientData.moveProjectToRunningDialog.${this.isProjectFinished
        ? "successMessage"
        : "successMessageAlt"
      }`, projectName);
  }

  onProjectConcluded(concludedProject: ProjectDetails) {
    this.projectDetails = concludedProject;
  }

  async onProjectDetailsChanged(newProjectDetails: ProjectDetails) {
    this.isApprovalDecisionChanged = !this.isNewProject &&
      newProjectDetails.clientData.projectApproval?.approvalResult !== 
      this.projectDetails.clientData.projectApproval?.approvalResult;
    
    const didProjectLocationChange =
      this.projectDetails.clientData.branch !=
      newProjectDetails.clientData.branch

    if (didProjectLocationChange) {
      const clientBranches = getBranchesOfClient()

      this.clientPanelAssignments.forEach((panel) => {
        if (panel.assignmentEndDate === null) {
          const matchingBranch = clientBranches.find(
            (branch) => branch.id === newProjectDetails.clientData.branch
          );

          updateComBox(
            panel.serialNumber, {
              currentAssignment: {
                currentProjectBranch: matchingBranch?.branchNumber
              }
            }
          )
        }
      });
    }

    const newProjectApproval = newProjectDetails.clientData.projectApproval;
    const didProjectApprovalChange =
      newProjectApproval?.approvalResult !=
      this.projectDetails.clientData.projectApproval?.approvalResult;

    this.projectDetails = newProjectDetails;

    if (
      newProjectApproval &&
      newProjectApproval.approvalResult !== ApprovalResult.PENDING &&
      !this.isNewProject &&
      didProjectApprovalChange
    ) {
      const approvalStep = {
        createdBy: UserModule.activeUserIdentifier,
        creationTimestamp: newProjectApproval.recordInfo.recordedAt
          .toDate()
          .toISOString(),
        orderAccepted:
          newProjectApproval.approvalResult === ApprovalResult.APPROVED ? 1 : 0,
      };

      await saveProjectStep(this.projectDetails, 2, approvalStep, true, undefined, true);
    }

    await this.onSaveProjectDetails(newProjectDetails);
  }

  /**
   * Assigns a picked device to an apartment, or to one of its rooms under room-level device
   * assignment (the devices tab then emits the room's id).
   */
  async onAssignIresDevicesToContactPerson(contactPerson: ContactPersonInfo, roomId: string | null = null) {
    const selectedDevice = await this.selectDevice.show(
      this.projectDetails
    );

    if (selectedDevice) {
      if (isClientPanel(selectedDevice)) {
        const selectedClientPanel = selectedDevice as ClientPanel;

        await this.assignIresDevice.show(
          selectedClientPanel,
          this.projectDetails,
          contactPerson,
          this.clientPanelAssignments.length + 1,
          undefined,
          undefined,
          roomId
        );
      }
      else {
        // TODO: Add generic device assignment
        const selectedGenericDevice = selectedDevice as DeviceOverview;

        await this.assignGenericDevice.show(
          selectedGenericDevice,
          this.projectDetails,
          contactPerson,
          this.genericDeviceAssignments.length + 1,
          undefined,
          undefined,
          roomId
        );
      }
    }
  }

  async onFindIresDeviceToAssignForFirstContactPerson() {
    const contactPerson = this.projectDetails.clientData.contactPersons[0];
    this.onFindIresDeviceToAssign(contactPerson);
  }

  async onFindIresDeviceToAssign(contactPerson: ContactPersonInfo) {
    const selectedClientPanel = await this.findIresDeviceForProjectAssignment.show(
      this.projectDetails
    );

    if (selectedClientPanel) {
      await this.assignIresDevice.show(
        selectedClientPanel,
        this.projectDetails,
        contactPerson,
        this.clientPanelAssignments.length + 1
      );
    }
  }

  beforeDestroy() {
    this.subscriptions.forEach((disposable) => disposable());

    const state = {
      projectDetails: this.projectDetails,
      clientPanelAssignments: this.clientPanelAssignments,
      genericDeviceAssignments: this.genericDeviceAssignments,
      reports: this.sortedReports,
      projectDetailsTab: this.selectedTab,
    };

    ProjectDetailsModule.cacheProjectDetailsState(state);
  }

  async onProjectApproved(orderAccepted: number) {
    const recordInfo = getRecordInfo();
    const approvalResult =
      orderAccepted === 1 ? ApprovalResult.APPROVED : ApprovalResult.REJECTED;

    const projectUpdate = clone(this.projectDetails);

    projectUpdate.clientData.projectApproval = {
      recordInfo: recordInfo,
      approvalResult: approvalResult,
    };

    await this.onProjectDetailsChanged(projectUpdate);
  }

  async onAppointmentUpdated() {
    this.updatedProjectDetails = true;
  }

  get deviceFilterIconRes() {
    return "mdi-filter-variant";
  }

  getTabKey(projectDetailsTab: ProjectDetailsTab) {
    return projectDetailsTab.toString();
  }

  get genericDevicesNotReleased() {
    return this.genericDeviceAssignments.filter(
      (assignment) => !assignment.assignmentEndDate
    );
  }

  get areAllDevicesSignedOff() {
    return this.clientPanelsNotSignedOff.length === 0 && this.genericDevicesNotReleased.length === 0;
  }

  get clientPanelsNotSignedOff() {
    return this.clientPanelAssignments.filter(
      (clientPanelAssignment) => !clientPanelAssignment.assignmentEndDate
    );
  }

  get concludeProjectTitle() {
    return this.$t("projectConclusion.concludeProject").toString();
  }

  get concludeProjectText() {
    const projectEndDate = this.projectDetails.projectConclusionData
      ?.projectConclusionDate;
    const projectFinishedBy = this.projectDetails.projectConclusionData
      ?.finishedBy;

    if (!projectEndDate || !projectFinishedBy) {
      return null;
    }

    const formattedEndDate = formatDateShort(projectEndDate);
    const formattedProjectFinishedBy = findNickname(
      projectFinishedBy.recordedByUserId
    );

    return this.$t("projectConclusion.formatProjectFinished", [
      formattedEndDate,
      formattedProjectFinishedBy,
    ]).toString();
  }

  get concludeProjectButtonState() {
    if (!this.canFinaliseProjectInPortal || !this.canEditProject) {
      return ButtonState.DISABLED;
    }
    
    if (this.isReadOnlyMode) {
      return ButtonState.DISABLED;
    }

    return this.isProjectFinished ? ButtonState.STEP_BUTTON_COMPLETED : ButtonState.STEP_BUTTON_INCOMPLETE;
  }

  get gzDeviceButtonTitle() {
    if (this.projectStatus?.projectSteps["11"]) {
      return this.$t("assignDevice.releaseDevices").toString();
    }
    return this.$t("projectStep.assignDevices").toString();
  }

  get gzDeviceButtonText() {
    const count = this.clientPanelsNotSignedOff.length + this.genericDevicesNotReleased.length;
    if (count === 0) return "";
    return this.$tc("assignDevice.devicesAssignedCount", count).toString();
  }

  get gzDeviceButtonState() {
    if (this.isReadOnlyMode) return ButtonState.DISABLED;
    if (this.areAllDevicesSignedOff && this.projectStatus?.projectSteps["11"]) {
      return ButtonState.STEP_BUTTON_COMPLETED;
    }
    return ButtonState.STEP_BUTTON_INCOMPLETE;
  }

  onGzDeviceButtonClick() {
    const index = this.tabs.indexOf(ProjectDetailsTab.DEVICES);
    if (index !== -1) {
      this.selectedTab = index;
    }
  }

  get isProjectFinished() {
    if (getProjectEndDateLegacy(this.projectDetails)) {
      return true;
    }

    return false;
  }

  onConcludeProject() {
    const index = this.tabs.indexOf(ProjectDetailsTab.CONCLUDE_PROJECT);

    if (index !== -1) {
      this.selectedTab = index;
    }
  }

  async onEditAssignment(
    deviceProjectAssignment: ClientPanelAssignment | GenericDeviceProjectAssignment,
    deviceToEdit: ClientPanel | DeviceOverview,
    contactPersonInfo: ContactPersonInfo,
    isReleasingAll?: boolean,
    shouldQueueClientPanels?: boolean,
    hasDependantAssignments?: boolean,
  ) {
    const serialNumber = (deviceProjectAssignment as ClientPanelAssignment).serialNumber;
    const isClientPanelAssignment =
      typeof serialNumber === "string" && serialNumber.trim().length > 0;

    if (!isClientPanelAssignment) {
      if (this.isProjectFinished || this.isReadOnlyMode) {
        return;
      }

      await this.assignGenericDevice.show(
        deviceToEdit as DeviceOverview,
        this.projectDetails,
        contactPersonInfo,
        (deviceProjectAssignment as GenericDeviceProjectAssignment).assignmentIndex,
        deviceProjectAssignment as GenericDeviceProjectAssignment,
        hasDependantAssignments
      );
      return;
    }

    const clientPanelAssignment = deviceProjectAssignment as ClientPanelAssignment;
    const clientPanel = deviceToEdit as ClientPanel;

    if (isReleasingAll && shouldQueueClientPanels) {
      this.clientPanelsToBeReleased.push({
        clientPanelAssignment,
        clientPanel,
        contactPersonInfo,
      });

      this.noOfClientPanelsToBeReleased++;
    }
    
    if (this.isProjectFinished || this.isReadOnlyMode) {
      this.closedAssignmentDetailsComponent.show(
        clientPanelAssignment,
        clientPanel
      );
      return;
    }

    if (!isReleasingAll) {
      await this.assignIresDevice.show(
        clientPanel,
        this.projectDetails,
        contactPersonInfo,
        clientPanelAssignment.assignmentIndex,
        clientPanelAssignment,
        hasDependantAssignments
      );
      return;
    }

    if (isReleasingAll && !this.currentlyReleasingClientPanel){
      this.currentlyReleasingClientPanel = clientPanel.serialNumber;
      
      const result = await this.assignIresDevice.show(
        clientPanel,
        this.projectDetails,
        contactPersonInfo,
        clientPanelAssignment.assignmentIndex,
        clientPanelAssignment,
        hasDependantAssignments
      );

      if (result || result === false) {
        if (this.clientPanelsToBeReleased.length > 0) {
          this.clientPanelsToBeReleased.splice(0, 1);
          this.currentlyReleasingClientPanel = null;
        }
      }

      return;
    }

    return;
  }
}
